export const candidatePosters = [
  {
    id: "technikum",
    title: "Technikum",
    src: "/assets/images/school-site/candidate/technikum.jpg"
  },
  {
    id: "szkola-branzowa",
    title: "Szkoła Branżowa",
    src: "/assets/images/school-site/candidate/branzowa.jpg"
  },
  {
    id: "plakat",
    title: "Informacje dla kandydatów",
    src: "/assets/images/school-site/candidate/Plakat-1.jpg"
  },
  {
    id: "plakat-sp",
    title: "Szkoła Policealna - Technik Usług Kosmetycznych",
    src: "/assets/images/school-site/candidate/Plakat-SP-710x1024-1.png"
  },
  {
    id: "ulotka-sp",
    title: "Ulotka informacyjna - Szkoła Policealna - Technik Usług Kosmetycznych",
    src: "/assets/images/school-site/candidate/Ulotka-SP-2-710x1024-1.png"
  }
];